import { Button } from '@dixa/lib-shared-habla';

import { useCopilotTrial } from 'utils/useCopilotTrial';
import { useCurrentUser } from 'utils/user';

export const SettingsCopilotTrialCallToAction = (): JSX.Element => {
  // TODO: Implement AX-820
  const { resetTrial } = useCopilotTrial();
  const { user } = useCurrentUser();

  return (
    <div>
      Add CTA content here
      {user.email?.endsWith('@dixa.com') && (
        <Button icon="dixa" onClick={resetTrial}>
          Reset trial
        </Button>
      )}
    </div>
  );
};
